"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePortalState = void 0;
var _react = require("react");
const usePortalState = () => {
  const _useState = (0, _react.useState)([]),
    nodes = _useState[0],
    setNodes = _useState[1];
  const addNode = (0, _react.useCallback)((id, element) => {
    setNodes(prevNodes => {
      const index = prevNodes.findIndex(item => item.id === id);
      // if the id already exists, replace the element
      if (index !== -1) {
        const copy = [...prevNodes];
        copy[index].element = element;
        return copy;
      }
      return [...prevNodes, {
        id,
        element
      }];
    });
  }, []);
  const filterInvisibleNodes = (0, _react.useCallback)(() => {
    setNodes(prevNodes => prevNodes.filter(node => node.element.props.visible));
  }, []);
  const removeNode = (0, _react.useCallback)(id => {
    setNodes(prevNodes => {
      const index = prevNodes.findIndex(item => item.id === id);
      if (index === -1) return prevNodes;
      const copy = [...prevNodes];
      const nodeMatch = prevNodes[index].element;
      const handleOnDidClose = () => {
        var _nodeMatch$props, _nodeMatch$props$onDi;
        (_nodeMatch$props = nodeMatch.props) === null || _nodeMatch$props === void 0 ? void 0 : (_nodeMatch$props$onDi = _nodeMatch$props.onDidClose) === null || _nodeMatch$props$onDi === void 0 ? void 0 : _nodeMatch$props$onDi.call(_nodeMatch$props);
        filterInvisibleNodes();
      };

      // set the visible prop to false to trigger exit animation
      copy[index].element = /*#__PURE__*/(0, _react.cloneElement)(nodeMatch, {
        visible: false,
        onDidClose: handleOnDidClose
      });
      return copy;
    });
  }, [filterInvisibleNodes]);
  return (0, _react.useMemo)(() => ({
    nodes,
    addNode,
    removeNode
  }), [nodes, addNode, removeNode]);
};
exports.usePortalState = usePortalState;